module.exports = __webpack_public_path__ + "static/media/calendar.0e3a6efb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/calendar.svg
// module id = 575
// module chunks = 0